import React from 'react';
import { useCurrentUser } from '../utils';
import { Loading } from './loading';

export const withCurrentUser = (WrappedComponent: any) => (props: any) => {
  const user = useCurrentUser();
  if (user) return <WrappedComponent {...props} user={user} />;
  return <Loading />;
};
